import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiSelectFilter } from '../../interfaces/multi-select-filter';

@Component({
  selector: 'app-custom-checkboxes',
  templateUrl: './custom-checkboxes.component.html',
  styleUrls: ['./custom-checkboxes.component.scss']
})
export class CheckboxListComponent {
  @Input({ required: true }) items!: MultiSelectFilter[];
  @Input({ required: true }) selectedItemsKeys: string[] = [];
  @Input() disabled: boolean = false;

  @Output() itemChecked: EventEmitter<MultiSelectFilter> = new EventEmitter<MultiSelectFilter>();

  isChecked(item: MultiSelectFilter): boolean {
    return this.selectedItemsKeys.includes(item.id);
  }

  selectItem(changedItem: MultiSelectFilter) {
    let index = this.selectedItemsKeys.indexOf(changedItem.id);

    if(index == -1) { 
      this.selectedItemsKeys.push(changedItem.id);
    } else {
      this.selectedItemsKeys.splice(index, 1);
    }

    this.itemChecked.emit(changedItem);
  }
}
